import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Modal, Row, Table, Pagination } from "antd";
import { connect } from "react-redux";
import { fetchFeedback } from "../../store/actions/feedbackActions";
import ViewForm from "./ViewForm";

const Feedback = ({ feedback, fetchFeedback }) => {
  const [formError] = useState("");
  const [setLoading] = useState(false);
  const [type, setType] = useState("viewFeedback");
  const [review, setReview] = useState("");
  const [score, setScore] = useState({});
  const [createdAt, setCreatedAt] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [skip, setSkip] = useState(1);

  useEffect(() => {
    fetchFeedback(skip);
  }, [fetchFeedback, type, skip]);

  const openModal = (modalType, record) => {
    setIsModalVisible(true);
    setType(modalType);
    setReview(record.review);
    setCreatedAt(record.createdAt);
    setScore(record.score);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const handleOk = async () => {
    setLoading(true);
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "User",
      dataIndex: "user",
      key: "review",
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => a.user.localeCompare(b.user),
    },
    {
      title: "PPlan",
      dataIndex: "pplan",
      key: "review",
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => a.pplan.localeCompare(b.pplan),
    },
    {
      title: "Review",
      dataIndex: "review",
      key: "review",
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => a.review.localeCompare(b.review),
    },
    {
      title: "Scores",
      dataIndex: "score",
      key: "score",
      sortDirections: ["ascend", "descend"],
      render: (_, record) => (
        <div>
          {record.score
            ? Object.keys(record.score).map((score) => {
                const numbScore = record.score[score];
                return (
                  <Button
                    style={{
                      marginRight: 5,
                      borderColor:
                        numbScore > 3
                          ? "#389e0d"
                          : numbScore < 4 && numbScore > 2
                          ? "#fa8c16"
                          : "#cf1322",
                      backgroundColor:
                        numbScore > 3
                          ? "#389e0d"
                          : numbScore < 4 && numbScore > 2
                          ? "#fa8c16"
                          : "#cf1322",
                      color: "#fff",
                    }}
                  >
                    {score}:{numbScore}
                  </Button>
                );
              })
            : null}
        </div>
      ),
    },
    {
      title: "CreatedAt",
      dataIndex: "createdAt",
      key: "createdAt",
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (_, record) => (
        <div>
          <Row gutter={4}>
            <Col>
              <Button
                type="primary"
                onClick={() => openModal("viewFeedback", record)}
              >
                View
              </Button>
            </Col>
          </Row>
        </div>
      ),
    },
  ];

  return (
    <div>
      {formError ? (
        <div style={{ marginTop: 20 }}>
          {" "}
          <Alert message={formError} type="error" />{" "}
        </div>
      ) : (
        ""
      )}

      <div style={{ marginTop: 20 }}>
        <Table columns={columns} dataSource={feedback.feedbacks} />
        <Pagination total={feedback.total} current={skip} onChange={setSkip} />
      </div>

      <Modal
        title="View Feedback"
        visible={isModalVisible}
        onCancel={closeModal}
        onOk={handleOk}
        footer={[
          <Button key="back" onClick={closeModal}>
            Close
          </Button>,
        ]}
      >
        <ViewForm
          review={review}
          createdAt={createdAt}
          scores={
            score ? Object.keys(score).map((sc) => `${sc}:${score[sc]}`) : []
          }
        />
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  feedback: state.feedback.feedback,
  searchError: state.tracks.searchError,
});

export default connect(mapStateToProps, { fetchFeedback })(Feedback);
